export default "__VITE_ASSET__Dnv77M5n__"